import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import UserLayout from "../layout/UserLayout";
import RiceProcess from "../components/RiceProcess";
import API_BASE, { UPLOADS_BASE } from "../../api";

const RiceProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/rice_manager/get_rice_products.php`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setProducts(data);
        else if (data && Array.isArray(data.products)) setProducts(data.products);
      })
      .catch((err) => console.error("Error loading rice products:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <UserLayout>
      {/* Hero Banner */}
      <div className="relative bg-gradient-to-r from-emerald-950 via-green-950 to-stone-900 text-white pt-32 pb-20 px-6 sm:px-12 text-center">
        <div className="max-w-4xl mx-auto">
          <span className="text-emerald-400 font-semibold tracking-widest text-sm uppercase">
            Ancient Heirloom Grains
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold mt-3 mb-4 tracking-tight">
            Traditional Ceylon Rice
          </h1>
          <p className="text-lg text-emerald-100 max-w-2xl mx-auto leading-relaxed">
            Nutrient-rich, low-glycemic traditional rice varieties cultivated for millennia in Sri Lanka. Including Suwandel, Kalu Heenati, Pachchaperumal, and Kuruluthuda.
          </p>
        </div>
      </div>

      {/* Products Section */}
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16">
        <div className="flex flex-col sm:flex-row items-baseline justify-between mb-10 pb-4 border-b border-gray-200">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">Heirloom Rice Varieties</h2>
            <p className="text-sm text-gray-500 mt-1">100% Organic, non-hybrid, chemical-free native grains</p>
          </div>
          <span className="text-sm text-emerald-800 font-semibold mt-2 sm:mt-0">
            {products.length} Products Available
          </span>
        </div>

        {loading ? (
          <div className="py-20 text-center text-gray-500">
            <div className="inline-block w-8 h-8 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin mb-3"></div>
            <p>Loading Traditional Rice collection...</p>
          </div>
        ) : products.length === 0 ? (
          <div className="py-16 text-center text-gray-500 bg-gray-50 rounded-2xl">
            <p className="text-lg">No rice products listed at the moment.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {products.map((p) => {
              const imgUrl = p.image ? `${UPLOADS_BASE}/rice_products/${p.image}` : null;
              return (
                <div
                  key={p.id}
                  className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col group"
                >
                  <div className="relative h-56 bg-emerald-50 overflow-hidden">
                    {imgUrl ? (
                      <img
                        src={imgUrl}
                        alt={p.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-emerald-400">
                        <i className="fas fa-seedling text-4xl"></i>
                      </div>
                    )}
                    {p.net_weight && (
                      <span className="absolute top-3 right-3 bg-black/70 backdrop-blur-sm text-white text-xs font-semibold px-2.5 py-1 rounded-full">
                        {p.net_weight}
                      </span>
                    )}
                  </div>

                  <div className="p-5 flex-1 flex flex-col justify-between">
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 group-hover:text-emerald-800 transition">
                        {p.title}
                      </h3>
                      {p.description && (
                        <p className="text-sm text-gray-600 mt-2 line-clamp-2 leading-relaxed">
                          {p.description}
                        </p>
                      )}
                    </div>

                    <div className="mt-5 pt-4 border-t border-gray-100 flex items-center justify-between">
                      <Link
                        to={`/rice/${p.id}`}
                        className="text-sm font-semibold text-emerald-800 hover:text-emerald-950 flex items-center gap-1 group/btn"
                      >
                        <span>View Details</span>
                        <i className="fas fa-arrow-right text-xs transition-transform group-hover/btn:translate-x-1"></i>
                      </Link>
                      <Link
                        to="/contact"
                        className="px-3 py-1.5 rounded-lg text-xs font-medium bg-emerald-50 text-emerald-800 hover:bg-emerald-100 transition"
                      >
                        Inquire
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Rich Content: Traditional Paddy Cultivation & Eco-Farming */}
      <RiceProcess />
    </UserLayout>
  );
};

export default RiceProducts;
